import React from 'react';
import {
  ServiceCentreHyperlink,
  TelephoneContactNumberHyperlink,
} from 'components/Hyperlinks';
import TemplateErrorPage from './TemplateErrorPage/TemplateErrorPage';

const HasLicenceDktExpiredErrorPage: React.FC = () => {
  return (
    <TemplateErrorPage
      pageTitle='Sorry, you cannot proceed online'
      defaultAlertTitle='You already have a NSW Driver Licence'
      contactDescription={contactDescription}
    />
  );
};

export default HasLicenceDktExpiredErrorPage;

const contactDescription = (
  <p>
    Need help? Call us on <TelephoneContactNumberHyperlink /> or visit a{' '}
    <ServiceCentreHyperlink />.
  </p>
);
